import React from 'react';
import { IPagePickUpLocations } from '../../interfaces';

const mapContainerStyle = {
  width: '100%',
  height: '663px',
};

interface IProps {
  pagePickupLocations: IPagePickUpLocations;
}

const PagePickupLocations = ({ pagePickupLocations: _ }: IProps) => {
  return (
    <div className='centered-content vertical-margin' style={mapContainerStyle}>
      <iframe
        src="https://www.google.com/maps/d/embed?mid=1_QoXBUcRPb8Lu-zgCusFYEktKkhB95s&ehbc=2E312F&ll=64.11059432031217%2C-21.910462349999996&z=12"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Pickup Locations Map"
      />
    </div>
  );
};

export default PagePickupLocations;
